const HisStethoscope = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg
      style={sx}
      stroke={strokeColor}
      width="33"
      height="33"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.35402 3.07115C7.35877 3.15494 7.38976 3.23512 7.44259 3.30033C7.49542 3.36554 7.56742 3.41249 7.6484 3.43452C7.72938 3.45656 7.81524 3.45257 7.89383 3.42312C7.97242 3.39366 8.03976 3.34024 8.08631 3.27041C8.13286 3.20058 8.15628 3.11788 8.15324 3.03401C8.1502 2.95014 8.12086 2.86934 8.06937 2.80307C8.01788 2.73679 7.94686 2.68838 7.86634 2.6647C7.78583 2.64101 7.6999 2.64325 7.62073 2.67109H6.28719C5.57984 2.67109 4.90146 2.95209 4.40128 3.45226C3.90111 3.95243 3.62012 4.63081 3.62012 5.33816V12.0058C3.62012 14.1279 4.4631 16.163 5.96362 17.6636C7.46414 19.1641 9.49928 20.0071 11.6213 20.0071C13.7434 20.0071 15.7785 19.1641 17.2791 17.6636C18.7796 16.163 19.6226 14.1279 19.6226 12.0058V5.33816C19.6226 4.63081 19.3416 3.95243 18.8414 3.45226C18.3412 2.95209 17.6628 2.67109 16.9555 2.67109H15.6219C15.5957 2.69736 15.5748 2.72854 15.5606 2.76287C15.5464 2.79719 15.5391 2.83397 15.5391 2.87112C15.5391 2.90827 15.5464 2.94506 15.5606 2.97938C15.5748 3.0137 15.5957 3.04488 15.6219 3.07115C15.6482 3.09742 15.6794 3.11826 15.7137 3.13247C15.748 3.14669 15.7848 3.15401 15.822 3.15401C15.8591 3.15401 15.8959 3.14669 15.9302 3.13247C15.9646 3.11826 15.9957 3.09742 16.022 3.07115"
        stroke={strokeColor}
        strokeWidth="2.66707"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6211 20.0084V21.342C11.6211 23.464 12.4641 25.4992 13.9646 26.9997C15.4651 28.5002 17.5003 29.3432 19.6223 29.3432C21.7444 29.3432 23.7795 28.5002 25.28 26.9997C26.7806 25.4992 27.6235 23.464 27.6235 21.342V16.0078"
        stroke={strokeColor}
        strokeWidth="2.66707"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6241 16.006C29.0971 16.006 30.2912 14.8119 30.2912 13.3389C30.2912 11.866 29.0971 10.6719 27.6241 10.6719C26.1511 10.6719 24.957 11.866 24.957 13.3389C24.957 14.8119 26.1511 16.006 27.6241 16.006Z"
        stroke={strokeColor}
        strokeWidth="2.66707"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisStethoscope;
